import { render } from "./DesktopSidebar.vue?vue&type=template&id=492dd638&scoped=true"
import script from "./DesktopSidebar.vue?vue&type=script&lang=js"
export * from "./DesktopSidebar.vue?vue&type=script&lang=js"

import "./DesktopSidebar.css?vue&type=style&index=0&id=492dd638&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492dd638"]])

export default __exports__